import { Component, Input } from '@angular/core';
import { DynamicFormControlComponent } from '../dynamic-form-control/dynamic-form-control.component';
import { DynamicFormGroup } from '../../models/dynamic-form-group.model';
import { DynamicFormControl } from '../../models/dynamic-form-control.model';
import { CommonModule } from '@angular/common';
import { ControlType } from '../../models/control-type.enum';

@Component({
  selector: 'lib-dynamic-form-group',
  imports: [DynamicFormControlComponent, CommonModule],
  templateUrl: './dynamic-form-group.component.html',
  styleUrl: './dynamic-form-group.component.scss',
})
export class DynamicFormGroupComponent {
  @Input()
  group: DynamicFormGroup;

  @Input()
  nested: boolean;

  ngOnInit() {}

  get ControlType(): typeof ControlType {
    return ControlType;
  }

  get controls() {
    return this.group?.children.filter(
      (i) => i instanceof DynamicFormControl,
    ) as DynamicFormControl[];
  }

  get nestedGroups() {
    return this.group?.children.filter(
      (i) => i instanceof DynamicFormGroup,
    ) as DynamicFormGroup[];
  }
}
